import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './NavDurga.scss';

const navDurga = [
  {
    id: 1,
    name: 'Shailaputri',
    img: 'https://newslivetv.com/wp-content/uploads/2023/10/SHAILPUTRI.png',
    desc: 'Shailaputri, meaning "Daughter of the Mountain", is the first form of Durga. She is associated with the Muladhara chakra and rides a bull while holding a trident and lotus.'
  },
  {
    id: 2,
    name: 'Brahmacharini',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRJf5GC7guwGWPw0Q5GqmjDJKv0S7WFL7rSeBE9GqTwIhyvc1XPmyZ6TJi9tSuDbrt585w&usqp=CAU',
    desc: 'Brahmacharini represents austerity and penance. She holds a japa mala and kamandalu, symbolizing devotion and wisdom.'
  },
  {
    id: 3,
    name: 'Chandraghanta',
    img: 'https://mir-s3-cdn-cf.behance.net/projects/404/5cb132209486981.Y3JvcCwxNzI3LDEzNTAsMTkyLDcyMg.jpg',
    desc: 'Chandraghanta, adorned with a crescent moon on her forehead, symbolizes courage. She rides a tiger and is known for her bravery in battle.'
  },
  {
    id: 4,
    name: 'Kushmanda',
    img: 'https://sadhana.app/wp-content/uploads/2023/06/Ma-Kushmanda_01.jpg',
    desc: 'Kushmanda is believed to have created the universe with her divine smile. She has eight arms and rides a lion, radiating warmth and energy.'
  },
  {
    id: 5,
    name: 'Skandamata',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTRKjvMOZCtM6qfgl4511x1WWJjYTD0rpPcsg&s',
    desc: 'Skandamata is the mother of Skanda (Kartikeya). She rides a lion and carries her son in her lap, representing motherly love and strength.'
  },
  {
    id: 6,
    name: 'Katyayani',
    img: 'https://www.harekrsna.de/artikel/nava-durga/katyayani.jpg',
    desc: 'Katyayani was born to sage Katyayana and is known as the warrior goddess. She is associated with fierce power and is worshipped for victory and protection.'
  },
  {
    id: 7,
    name: 'Kalaratri',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRVj-zh7ZV8byLtSgQhLbQUWGPLXv5B01tOAA&s',
    desc: 'Kalaratri is the fiercest form of Durga, who destroys ignorance and darkness. She rides a donkey and has a dark complexion and fiery eyes.'
  },
  {
    id: 8,
    name: 'Mahagauri',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5jA3c0o6Eych1foRaOHztQGo2rJfHN3rX7uIfKr9tDxzQBgDvelwY9tzKZaG2E4gm0bg&usqp=CAU',
    desc: 'Mahagauri is the epitome of purity and calmness. She rides a white bull and blesses her devotees with peace and virtue.'
  },
  {
    id: 9,
    name: 'Siddhidatri',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSxy1HB6XNaUvwGG3wSkrfVZ4Lz1NCNziK8WQ&s',
    desc: 'Siddhidatri is the ninth form of Durga, known for granting supernatural powers and wisdom. She sits on a lotus and fulfills all spiritual desires.'
  },
];

const NavDurga = () => {
  const [selectedForm, setSelectedForm] = useState(null);

  const openPopup = (form) => {
    setSelectedForm(form);
  };

  const closePopup = () => {
    setSelectedForm(null);
  };

  return (
    <div className="navdurga-container">
      <InnerNav />
      <div className="navdurga-content">
        <Zodiac />

        <div className="festival-header">
          <h4>NavDurga – 9 Forms of Goddess Durga</h4>
        </div>

        <div className="festival-grid">
          {navDurga.map((form) => (
            <div className="festival-card" key={form.id} onClick={() => openPopup(form)}>
              <img
              src={form.img || 'https://i.pinimg.com/736x/d6/77/d9/d677d911e831a4c3ed828f47bb819833.jpg'}
                alt={form.name}
              />
              <p>{form.name}</p>
            </div>
          ))}
        </div>

        {selectedForm && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedForm.name}</h3>
              <img
              src={selectedForm.img || 'https://i.pinimg.com/736x/d6/77/d9/d677d911e831a4c3ed828f47bb819833.jpg'}
                alt={selectedForm.name}
              />
              <p>{selectedForm.desc}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default NavDurga;
